export default __webpack_public_path__ + "static/16708-415596be72a02afa78e068a7e01b06b7.jpg";